'use client';

import Statistics from "./_home/_components/statistics";
import TableMenu from "./_home/_components/tablemenu";
import Testimonial from "./_home/_components/testimonial";
import SimpleCalendar from "./_home/_components/SimpleCalendar";
// import NewsCards from "./_home/_components/NewsCards"; // Commented out NewsCards import
import BlogCards from "./_home/_components/BlogCards"; // Added BlogCards import
import { useEffect, useState } from "react";
import { getLanguage } from "@/utils/localStorageControl";
import { LANGUAGES } from "@/language";
import { useRouter } from "next/navigation";

export default function HomePage() {
  const [currentLang, setCurrentLang] = useState<string>('ko');
  const router = useRouter();
  
  useEffect(() => {
    const lang = getLanguage();
    setCurrentLang(lang);
  }, []);
  

  return (
    <div className="bg-white dark:bg-gray-900">
      <TableMenu/>
      
      <div className="max-w-[1280px] mx-auto px-4 py-12 text-center" data-aos="fade" data-aos-duration="500" data-aos-delay="300">
        <h2 className="text-3xl md:text-4xl font-bold !leading-[1.5] text-blue-600 dark:text-blue-400 mb-5">
          &ldquo;{(() => {
            const hasKey = <T extends object>(obj: T, key: string | number | symbol): key is keyof T => {
              return key in obj;
            };
            
            if (LANGUAGES.MAIN_PAGE.TITLE && 
                hasKey(LANGUAGES.MAIN_PAGE.TITLE, '한번 하면 돌이킬 수 없는 성형') && 
                hasKey(LANGUAGES.MAIN_PAGE.TITLE['한번 하면 돌이킬 수 없는 성형'], currentLang)) {
              return LANGUAGES.MAIN_PAGE.TITLE['한번 하면 돌이킬 수 없는 성형'][currentLang];
            }
            return '한번 하면 돌이킬 수 없는 성형';
          })()},<br/>
          {(() => {
            const hasKey = <T extends object>(obj: T, key: string | number | symbol): key is keyof T => {
              return key in obj;
            };
            
            if (LANGUAGES.MAIN_PAGE.TITLE && 
                hasKey(LANGUAGES.MAIN_PAGE.TITLE, '당신은 얼마나 준비 됬나요') && 
                hasKey(LANGUAGES.MAIN_PAGE.TITLE['당신은 얼마나 준비 됬나요'], currentLang)) {
              return LANGUAGES.MAIN_PAGE.TITLE['당신은 얼마나 준비 됬나요'][currentLang];
            }
            return '당신은 얼마나 준비 됬나요';
          })()}&rdquo;
        </h2>
        <p className="text-xl text-gray-600 dark:text-gray-400">
          <span className="font-bold" style={{ color: "#0000ff" }}>Kuxy</span>
          {(() => {
            const hasKey = <T extends object>(obj: T, key: string | number | symbol): key is keyof T => {
              return key in obj;
            };
            
            if (LANGUAGES.MAIN_PAGE.TITLE && 
                hasKey(LANGUAGES.MAIN_PAGE.TITLE, '에서 당신의 성형 여정을 완벽하게 준비하세요') && 
                hasKey(LANGUAGES.MAIN_PAGE.TITLE['에서 당신의 성형 여정을 완벽하게 준비하세요'], currentLang)) {
              return LANGUAGES.MAIN_PAGE.TITLE['에서 당신의 성형 여정을 완벽하게 준비하세요'][currentLang];
            }
            return '에서 당신의 성형 여정을 완벽하게 준비하세요';
          })()}
        </p>
      </div>
      
      <div className="relative">
        <SimpleCalendar/>
        <div className="flex justify-center gap-4 mt-4 mb-12">
          <a 
            href="/calendar" 
            className="inline-flex items-center px-6 py-3 text-base font-medium text-white bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full hover:from-blue-600 hover:to-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 shadow-lg transform transition-all duration-200 hover:scale-105"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
            </svg>
            나의 여정 꾸미기
          </a>
        </div>
      </div>
      {/* <NewsCards/> */}
      {/* <Statistics/> */}
      {/* <Testimonial/> */}
    </div>
  )
}